
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_105_3356)"}},[_c('path',{attrs:{"d":"M18.333 14.1v2.5a1.667 1.667 0 01-1.816 1.667 16.492 16.492 0 01-7.192-2.559 16.25 16.25 0 01-5-5 16.492 16.492 0 01-2.558-7.225 1.666 1.666 0 011.658-1.816h2.5A1.667 1.667 0 017.592 3.1c.105.8.3 1.586.583 2.342A1.667 1.667 0 017.8 7.2L6.742 8.258a13.333 13.333 0 005 5L12.8 12.2a1.667 1.667 0 011.758-.375c.756.282 1.542.478 2.342.583a1.666 1.666 0 011.433 1.692z","stroke":"#667080","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_105_3356"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    